'use client';

import type { InteractionApiError } from '@/app/utils/auth-interactions-api';
import type { TerminalInteractionState } from './types';

export function terminalStateFromError(error: InteractionApiError): TerminalInteractionState {
  return {
    title: error.title,
    message: error.userMessage,
    actionLabel: error.kind === 'unavailable' ? 'Try again' : 'Start over',
  };
}

export function approvedElsewhereState(): TerminalInteractionState {
  return {
    title: 'Magic link approved',
    message:
      'Return to the window or device where you requested the link to finish signing in. If that window is closed, start over.',
    actionLabel: 'Start over',
    actionVariant: 'secondary',
  };
}

export function missingResumeState(): TerminalInteractionState {
  return {
    title: 'This sign-in request was already used',
    message: 'Start over to continue signing in.',
    actionLabel: 'Start over',
  };
}

export default function TerminalInteractionStateView({
  state,
  onRestart,
}: {
  state: TerminalInteractionState;
  onRestart: () => void;
}) {
  const actionClassName =
    state.actionVariant === 'secondary'
      ? 'btn text-zinc-700 border border-slate-300 bg-white hover:bg-slate-50 w-full'
      : 'btn text-white bg-blue-500 hover:bg-blue-700 w-full';

  return (
    <div className="w-full max-w-lg">
      <div className="mb-6">
        <h2 className="h3 font-merriweather mb-2">{state.title}</h2>
        <p className="text-sm text-slate-600">{state.message}</p>
      </div>

      <div>
        <button
          type="button"
          onClick={onRestart}
          className={actionClassName}
        >
          {state.actionLabel || 'Start over'}
        </button>
      </div>
    </div>
  );
}
